import React, { useState, SyntheticEvent } from 'react';
import { connect, useDispatch } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { Avatar } from 'Common/components/Atoms/Avatar';
import { Div } from 'Common/components/Atoms/Div';
import { DropMenu } from 'Common/components/Molecules/DropMenu';
import { Flex } from 'Common/components/Atoms/Flex';
import { FontIcon } from 'Common/components/Atoms/FontIcon';
import { Text } from 'Common/components/Atoms/Text';
import {
  faChevronDown,
  faChevronUp,
  faUser,
} from '@fortawesome/pro-solid-svg-icons';
import { useTheme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import logo from '../../resources/review-logo.svg';
import { faSignOut } from '@fortawesome/pro-regular-svg-icons';
import { User } from '../../models/User';
import { accountSelector } from 'selectors/Account';
import { actions as LoginActions } from 'reducers/login';

const useStyles = makeStyles(() => {
  return {
    logo: {
      background: `no-repeat url(${logo})`,
      width: '177px',
      height: '30px',
    },
  };
});

interface Props {
  user: User | null;
}

export function ReviewSignupHeader(props: Props): JSX.Element {
  const [showDropMenu, setShowDropMenu] = useState(false);
  const [anchorEl, setAnchorEl] = useState<Element | null>(null);
  const { user } = props;
  const theme = useTheme();
  const classes = useStyles();
  const dispatch = useDispatch();

  const items = [
    {
      title: 'Logout',
      url: '/logout',
      icon: faSignOut,
      onClick: (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();
        setShowDropMenu(false);
        dispatch(LoginActions.logout());
      },
    },
  ];

  if (user?.reviewer_profile?.is_onboarded) {
    items.unshift({
      title: 'Settings',
      url: '/dash/user/settings',
      icon: faUser,
      onClick: () => setShowDropMenu(false),
    });
  }

  return (
    <Flex
      alignItems="center"
      height="40px"
      px="10px"
      background={theme.palette.primary.dark}
      borderBottom={`1px solid ${theme.palette.divider}`}
    >
      <NavLink to="/">
        <div className={classes.logo} />
      </NavLink>
      {user && (
        <React.Fragment>
          <Div
            style={{ position: 'relative', cursor: 'pointer' }}
            ml="auto"
            onClick={(event: SyntheticEvent) => {
              setShowDropMenu(true);
              setAnchorEl(event.currentTarget);
            }}
            mr="10px"
          >
            <Flex alignItems="center" justifyContent="flex-end">
              <Div mr="10px">
                <Avatar src={user.photo_url} alt={user.name} size="20px" />
              </Div>
              <Text variant="body1" color={theme.palette.common.white}>
                {user.name}
                <FontIcon
                  icon={showDropMenu ? faChevronUp : faChevronDown}
                  size="xs"
                  ml="10px"
                />
              </Text>
            </Flex>
          </Div>
          <DropMenu
            id="accountSelector"
            anchorEl={anchorEl}
            show={showDropMenu}
            items={items}
            transformOrigin={{ vertical: -32, horizontal: 'left' }}
            dismiss={() => setShowDropMenu(false)}
          />
        </React.Fragment>
      )}
    </Flex>
  );
}

function mapStateToProps(state: any) {
  const account = accountSelector(state);
  return {
    user: account.user,
  };
}

export default connect(mapStateToProps)(ReviewSignupHeader);
